import * as React from 'react';

import Button from 'components/shared/Button';

import { SiteMessageState } from 'domains/ui';

type SiteMessageProps = {
  allowClose?: boolean;
  closeSiteMessage?: () => void;
  siteMessage: SiteMessageState;
};

function SiteMessage({
  siteMessage,
  closeSiteMessage = () => {},
  allowClose = true,
}: SiteMessageProps) {
  return (
    <div className={`mmv ${siteMessage.messageType}`} role="alert">
      <p className="mmv__message">{siteMessage.message}</p>
      {allowClose && (
        <Button
          type="icon"
          icon="times"
          a11yText="Close Message"
          className="mmv__close"
          id="mmv__close"
          onClick={() => closeSiteMessage()}
        />
      )}
    </div>
  );
}

export default SiteMessage;
